import { normalizeRole, isSuperAdminRole } from "./roles";

/**
 * Is the logged-in user Club Central platform staff (CC admin /
 * superadmin) — as opposed to a customer's tenant owner or tenant
 * staff?
 *
 * Why this is NOT simply authSource === 'central': the central login
 * flow stamps source 'tenant_owner' for ANY central-auth user who has
 * a user_tenant_access row for the tenant they're entering — including
 * CC platform admins (their central role name only survives in
 * userRole). 'central' effectively means "central user with no access
 * row", which is never true for staff browsing a tenant they manage.
 * The 2026-06 CC drawer shipped on the naive check and was invisible
 * to actual CC admins; the ccStaffOnly Email Verification nav item had
 * the same latent bug.
 *
 * The discriminator that works (and that the ClubCentral Manager link
 * has used all along): central-auth source AND the central role is
 * not "Tenant Owner".
 */
export function isPlatformStaff(): boolean {
  const authSource = localStorage.getItem("authSource");
  return (
    (authSource === "central" || authSource === "tenant_owner") &&
    normalizeRole(localStorage.getItem("userRole")) !== "tenant_owner"
  );
}

/**
 * Is the user a platform Super Admin (Club Central owner)? They can
 * switch into and operate in EVERY tenant, not just ones they have an
 * access row for. Keep the role name in sync with the central `roles`
 * table and backend utils/platformRoles.js.
 */
export function isSuperAdmin(): boolean {
  return isSuperAdminRole(localStorage.getItem("userRole"));
}
